import React, {
  useMemo,
} from 'react';
import {
  useLocation,
  useNavigate,
} from 'react-router-dom';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import {
  DASHBOARD_PATHS,
} from 'views/EMR/access';
import {
  usePCCAvailability,
} from 'views/EMR/hooks/pcc';
import RTMIcon from 'core/icons/RTMIcon';
import TempoIcon from 'core/icons/TempoIcon';
import CCMIcon from 'core/icons/CCMIcon';
import PCCIcon from 'core/icons/pcc';

const iconClassName = '!w-4 !h-4';
const tabClassName = '!p-2 !min-h-[48px] !normal-case !font-semibold';

const tabs = [{
  Icon: PCCIcon,
  value: DASHBOARD_PATHS.OVERVIEW,
  label: 'Overview',
}, {
  Icon: TempoIcon,
  value: DASHBOARD_PATHS.TEMPO,
  label: 'Tempo',
}, {
  Icon: RTMIcon,
  value: DASHBOARD_PATHS.RTM,
  label: 'RTM',
}, {
  Icon: CCMIcon,
  value: DASHBOARD_PATHS.CCM,
  label: 'CCM',
}];

export default function Navigation() {
  const location = useLocation();
  const navigate = useNavigate();
  const { isCcmAvailable } = usePCCAvailability();
  const visibleTabs = useMemo(
    () => tabs.filter(({ value }) => (
      value !== DASHBOARD_PATHS.CCM || isCcmAvailable
    )),
    [isCcmAvailable],
  );
  const tabValueSet = useMemo<Set<string>>(() => (
    new Set<string>([
      ...visibleTabs.map(({ value }) => value),
      DASHBOARD_PATHS.ROOT,
    ])
  ), [visibleTabs]);
  const isDashboardMenuItem = tabValueSet.has(location.pathname);
  const tabValue = useMemo(() => {
    if (!isDashboardMenuItem || location.pathname === DASHBOARD_PATHS.ROOT) {
      return DASHBOARD_PATHS.OVERVIEW;
    }

    return location.pathname;
  }, [isDashboardMenuItem, location.pathname]);

  return isDashboardMenuItem && visibleTabs.length > 0 ? (
    <Tabs
      className="!min-h-[48px] w-full border-b border-b-gray-200 px-4 populate-route-tabs"
      value={tabValue}
      onChange={(_event, value: string) => {
        navigate(value);
      }}
    >
      {visibleTabs.map(({ Icon, ...tabOptions }) => (
        <Tab
          key={tabOptions.value}
          className={tabClassName}
          iconPosition="start"
          {...tabOptions}
          icon={<Icon className={iconClassName} />}
        />
      ))}
    </Tabs>
  ) : null;
}
